export const GET_SCRIPTS_GRAPHQL_QUERY = /* GraphQL */ `
    query GetScripts($query: String!, $first: Int!, $after: String) {
        scriptTags(first: $first, query: $query, after: $after, reverse: true) {
            edges {
                node {
                    id
                    src
                }
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
`;

export interface GetScriptsGraphQLResponse {
    scriptTags: {
        nodes: GetScriptsGraphQL[];
    };
}

export interface GetScriptsGraphQL {
    id: string;
    src: string;
}
